import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { BufferTargetType, BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { UniformBufferManager } from "../../DriverDesign/RenderDevice/UniformBufferManager/UniformBufferManager";
export class WebGLUniformBufferManager extends UniformBufferManager {
    constructor(engine, offsetAlignment) {
        super(true);
        this.engine = engine;
        this.byteAlign = offsetAlignment;
        engine.on("endFrame", this, this.endFrame);
        engine.on("startFrame", this, this.startFrame);
    }
    createGPUBuffer(size, name, data) {
        let buffer = this.engine.createBuffer(BufferTargetType.UNIFORM_BUFFER, BufferUsage.Dynamic);
        buffer.bindBuffer();
        buffer.setDataLength(size);
        if (data) {
            buffer.setData(data, 0);
        }
        return buffer;
    }
    writeBuffer(buffer, data, offset, size) {
        buffer.bindBuffer();
        let gl = this.engine.gl;
        gl.bufferSubData(buffer._glTarget, offset, new Float32Array(data, offset, size / 4));
        LayaGL.statAgent.recordCTData(StatElement.CT_UBOBufferUploadCount, 1);
        LayaGL.statAgent.recordCTData(StatElement.CT_UBOBufferUploadMemory, size / 1048576);
    }
}
